module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/arrow-em_secondary-a582abee5fb20957bb1370fddad1590d.svg";